import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9 13.945a4.945 4.945 0 1 1 0-9.89 4.945 4.945 0 0 1 0 9.89m8.704-3.695A.37.37 0 0 0 18 9.9V8.1a.37.37 0 0 0-.296-.35l-1.628-.409a.6.6 0 0 1-.387-.353l-.536-1.295a.6.6 0 0 1 .023-.523l.863-1.44A.37.37 0 0 0 16 3.271L14.728 2a.37.37 0 0 0-.457-.039l-1.441.863a.6.6 0 0 1-.523.022l-1.295-.536a.6.6 0 0 1-.354-.386L10.25.296A.37.37 0 0 0 9.9 0H8.1a.37.37 0 0 0-.35.296l-.408 1.628a.6.6 0 0 1-.354.386l-1.295.536a.6.6 0 0 1-.523-.022l-1.441-.863a.37.37 0 0 0-.457.04L2 3.271a.37.37 0 0 0-.039.457l.863 1.441c.087.14.097.376.023.523l-.536 1.295a.6.6 0 0 1-.387.353l-1.628.41A.37.37 0 0 0 0 8.098V9.9c0 .165.133.322.296.35l1.628.408c.16.038.334.197.387.353l.536 1.295a.6.6 0 0 1-.023.524l-.863 1.44a.37.37 0 0 0 .039.457L3.272 16a.37.37 0 0 0 .457.04l1.441-.865a.6.6 0 0 1 .523-.022l1.295.536a.6.6 0 0 1 .354.387l.408 1.628A.37.37 0 0 0 8.1 18h1.8a.37.37 0 0 0 .35-.296l.408-1.628a.6.6 0 0 1 .354-.387l1.295-.536a.6.6 0 0 1 .523.022l1.441.864a.37.37 0 0 0 .457-.039L16 14.727a.37.37 0 0 0 .039-.457l-.863-1.44a.6.6 0 0 1-.023-.524l.536-1.295a.6.6 0 0 1 .387-.353z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
